import { observable, action } from 'mobx'
import { IUser } from '@/model/types/user'

export default class UserStore {
    @observable
    public token: string = ''
    public userInfo: IUser | null = null

    @action
    public setToken(token: string) {
        this.token = token
    }

    @action
    public setUserInfo(userInfo: IUser) {
        this.userInfo = userInfo
    }
}

export const userStore = new UserStore()
